module.exports = __webpack_public_path__ + "static/media/fees.f0893fec.png";